"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 Copyright (c) 2018 Wells Fargo. 333 Market St., San Francisco, CA 94105 All rights reserved.
 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.
 */

/**
 * A generic context holder supporting storage and retrieval of objects by key. As this
 * is a singleton object, this module is used for model data storage for configuration,
 * loaded data, requests and responses and other miscellaneous information.
 *
 * Provides three constant keys for common configuration objects
 * - **internal** Internally managed configuration
 * - **external** Externally provided configuration
 * - **bundle** The resource bundle
 *
 * @module core-config
 *
 * @author Nathan Freeling
 * @copyright 2018 Wells Fargo, All rights reserved.
 */

/**
 * Use this key to store and lookup the SDK internal configuration object.
 *
 * @constant internal
 * @type {string}
 */
var internal = 'internal';

/**
 * Use this key to store and lookup the SDK external configuration object. This
 * is the partner supplied "SDK Configuration Object"
 *
 * @constant external
 * @type {string}
 */
var external = 'external';

/**
 * Use this key to store and lookup the SDK resource bundle.
 *
 * @constant bundle
 * @type {string}
 */
var bundle = 'bundle';
var _conf = {};

/**
 * Retrieve a stored object by key
 *
 * @param {string} key The key of the configuration object
 * @return {object} The configuration object or {} if none exists
 */
function get(key) {
  return _conf[key] || {};
}

/**
 * Store an object by key
 *
 * @param {string} key The key of the configuration object
 * @param {object} conf The configuration object to store
 */
function set(key, conf) {
  _conf[key] = conf;
}

/**
 * Check if a key has a value
 *
 * @param {string} key The key of the configuration object
 * @return {boolean} true iuf this key has a value, false otherwise
 */
function contains(key) {
  return !!_conf[key];
}

/**
 * Remove all configuration objects
 */
function empty() {
  _conf = {};
}
var _default = exports["default"] = {
  get: get,
  set: set,
  contains: contains,
  empty: empty,
  internal: internal,
  external: external,
  bundle: bundle
};
//# sourceMappingURL=index.js.map